import { IDownloadEntregaObraClienteArquivoByIdUseCase } from "../../../presentation/useCases/read/download_entrega_obra_cliente_arquivo_by_id_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * DownloadEntregaObraClienteArquivoByIdUseCase
 */

export class DownloadEntregaObraClienteArquivoByIdUseCase implements IDownloadEntregaObraClienteArquivoByIdUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async downloadEntregaObraClienteArquivoById(
    idEntregaObraClienteArquivo: number,
    imageName: string,

  ): Promise<void> {
    const blob = await this.repository.downloadEntregaObraClienteArquivoById(idEntregaObraClienteArquivo);

    if (!blob) throw new Error('Falha ao buscar dados da imagem!');

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', String(imageName));
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

  }

}
